import { useHtmlElementFromTemplateRef } from '@/composition/useHtmlElementFromTemplateRef'
import type { Ref } from '@/composition/vue/compositionApi'
import type { AnyTemplateElement } from '@/components/types'
import { useResizeObserver } from '@/composition/resizeObserver'
import { computed, ref } from '@/composition/vue/compositionApi'

type WidgetViewLayoutSizeObserverParams = {
  viewRef: Ref<AnyTemplateElement | null>
  viewScrollContainerRef: Ref<AnyTemplateElement | null>
  scrolledContentHeight: Ref<number>
}

export const useWidgetViewLayoutSizeObserver = ({
  viewRef,
  viewScrollContainerRef,
  scrolledContentHeight,
}: WidgetViewLayoutSizeObserverParams) => {
  const viewElementRef = useHtmlElementFromTemplateRef(viewRef)
  const viewScrollContainerElementRef = useHtmlElementFromTemplateRef(viewScrollContainerRef)

  const viewHeight = ref(0)
  useResizeObserver(viewElementRef, (entries) => {
    const target = entries[0].target as HTMLElement
    viewHeight.value = target.offsetHeight
  })

  const viewScrollContainerHeight = ref(0)
  useResizeObserver(viewScrollContainerElementRef, (entries) => {
    const target = entries[0].target as HTMLElement
    viewScrollContainerHeight.value = target.offsetHeight
  })

  const height = computed(() => {
    return viewHeight.value - viewScrollContainerHeight.value + scrolledContentHeight.value
  })

  return {
    height,
  }
}
